import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { X } from "lucide-react";

const PopupPresupuesto = ({ salarioNeto }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 5000); // Mostrar después de 5 segundos

    return () => clearTimeout(timer);
  }, []);

  if (!isVisible) return null;

  return (
    <div className="bg-gradient-to-r relative from-purple-600 to-indigo-600 text-white p-6 rounded-lg shadow-lg max-w-sm animate-pulse">
      <button
        onClick={() => setIsVisible(false)}
        className="absolute top-2 right-2 text-white hover:text-gray-200"
      >
        <X size={24} />
      </button>
      <h2 className="text-2xl font-bold mb-2">¿Te interesa ahorrar?</h2>
      <p className="mb-4">
        Aprovecha al máximo tu salario neto con nuestra calculadora de ahorros.
      </p>
      <p className="mb-4 font-extrabold text-7xl">←</p>
      <a
        href={`https://educacionlaboral.com.do/calculadora-presupuesto/?salarioNeto=${salarioNeto}`}
        className="block w-full bg-white text-purple-600 text-center py-2 px-4 rounded font-bold hover:bg-gray-100 transition duration-300"
      >
        Ir a Calculadora de Ahorros
      </a>
    </div>
  );
};

PopupPresupuesto.propTypes = {
  salarioNeto: PropTypes.number.isRequired,
};

export default PopupPresupuesto;
